import template	from "./plugin-authenticate.html";
import css		from "./plugin-authenticate.css";

import Plugin 	from "plugin";
import Class	from "class";

import AuthenticateDialog from "/lib/client/dialog-authenticate2.js";

class AuthenticatePlugin extends Plugin {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static get schema() {
    return({
      "description": "jFermi custom login screen",
      "type": "object",
      "properties": {
      }
    });
  }
  static get designer() {
    return({
      "category": "Plugin",
      "icon": {"context": "actions", "size": 16, "iconname": "page-simple"}
    });
  }
  static get meta() {
    return import.meta;
  }
  static enable() {    
    Class.hook(AuthenticateDialog, AuthenticatePlugin);
  }
  static disable() {
  }    
  constructor(...args) {
    super(...args);
  }
}

export default AuthenticatePlugin;